var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "interference") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    strokeWidth: 3,
    strokeLinecap: "round",
    points: "40,2 20,2 12,32 26,32 22,58 52,20 36,20 ",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterference);
export default __webpack_public_path__ + "static/media/interference.c425029ff286a0039cb60a28ac9113ba.svg";
export { ForwardRef as ReactComponent };